// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/icomoon/iconfont.css'
import { Modal } from 'iview';
import 'iview/dist/styles/iview.css';
// import MetaInfo from 'vue-meta-info'
import VConsole from 'vconsole'
// Vue.user(MetaInfo)
Vue.component('Modal', Modal);


// if (process.env.NODE_ENV === 'production') {
//   new VConsole()
// }
Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   let fullPath = to.fullPath.indexOf('?') > -1 ? to.fullPath.split('?')[0] : to.fullPath;
//   let num = fullPath.lastIndexOf('/')
//   let fullPathLength = fullPath.length - 1
//   if (num !== fullPathLength){
//     // let newPath = fullPath + '/'
//     let time = (new Date()).getTime()
//     router.push(newPath);
//     // window.location.href = 'https://dnaerapp.com' + newPath + '?' + time
//   } else {
//     next();
//   }
//   next();
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // mounted () {
  //   document.dispatchEvent(new Event('render-event-a'))
  // }
})



// WEBPACK FOOTER //
// ./src/main.js